__turbopack_context__.v({
  "favoritesIcon": "hzAQ8W_favoritesIcon",
  "iconsWrapper": "hzAQ8W_iconsWrapper",
});
